import { FETCH_USERS_BEGIN, FETCH_USERS_SUCCESS, FETCH_SEARCH_SUCCESS, FETCH_SEARCH_SUCCESS_HOME, FETCH_USERS_FAILURE } from './actionTypes';

export const fetchUsersBegin = () => ({
    type: FETCH_USERS_BEGIN
});

export const fetchUsersSuccess = (data) => ({
    type: FETCH_USERS_SUCCESS,
    payload: { data }
});

export const fetchSearchSuccess = (data) => ({
    type: FETCH_SEARCH_SUCCESS,
    payload: { data }
});

export const fetchSearchSuccessHome = (data) => ({
    type: FETCH_SEARCH_SUCCESS_HOME,
    payload: { data }
});

export const fetchUsersFailure = error => ({
    type: FETCH_USERS_FAILURE,
    payload: { error }
});